import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, ChangeDetectionStrategy, Output, Input, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ProfileEditFormMolec } from '../../molecs/profile-edit-form/profile-edit-form.molec.js';
import { ProfileInfoFormMolec } from '../../molecs/profile-info-form/profile-info-form.molec.js';

@Component({
  standalone: true,
  selector: 'organ-profile-form',
  imports: [ProfileEditFormMolec, ProfileInfoFormMolec],
  templateUrl: './profile-form.organ.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileFormOrgan implements OnInit {
  @Input() isReader = false;
  @Input() ui!: any;
  @Input() data!: any;
  @Output() action = new EventEmitter();
  constructor(private fb: FormBuilder, private cd: ChangeDetectorRef) {}

  ngOnInit(): void {}
}
